import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  ADMIN_CREATE_INSURANCE_FAILURE,
  ADMIN_CREATE_INSURANCE_REQUEST,
  ADMIN_CREATE_INSURANCE_SUCCESS,
  ADMIN_CREATE_PATIENT_GUARANTOR_FAILURE,
  ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST,
  ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS,
  ADMIN_DELETE_INSURANCE_FAILURE,
  ADMIN_DELETE_INSURANCE_REQUEST,
  ADMIN_DELETE_INSURANCE_SUCCESS,
  ADMIN_UPDATE_INSURANCE_FAILURE,
  ADMIN_UPDATE_INSURANCE_REQUEST,
  ADMIN_UPDATE_INSURANCE_SUCCESS,
  ADMIN_UPDATE_PATIENT_FAILURE,
  ADMIN_UPDATE_PATIENT_GUARANTOR_FAILURE,
  ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST,
  ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS,
  ADMIN_UPDATE_PATIENT_LOCATION_FAILURE,
  ADMIN_UPDATE_PATIENT_LOCATION_REQUEST,
  ADMIN_UPDATE_PATIENT_LOCATION_SUCCESS,
  ADMIN_UPDATE_PATIENT_REQUEST,
  ADMIN_UPDATE_PATIENT_SUCCESS,
} from "../actions/adminConstants";

function* savePatient(action: any): any {
  try {
    const result = yield call(ApiService.partialUpdateAdminPatient, {
      id: action.payload.patient.id,
      requestBody: action.payload.patient,
    });
    yield put({
      type: ADMIN_UPDATE_PATIENT_SUCCESS,
      payload: {
        patient: result,
        case_id: action.payload.adminCase_id,
      },
    });
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_PATIENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* createInsurance(action: any): any {
  try {
    const newInsurance = yield call(ApiService.createAdminInsurance, {
      requestBody: action.payload.insurance,
    });

    yield put({
      type: ADMIN_CREATE_INSURANCE_SUCCESS,
      payload: {
        case_id: action.payload.caseId,
        patient_id: action.payload.patientId,
        insurance: newInsurance,
      },
    });

    action.payload.onClose && action.payload.onClose(null);
  } catch (e) {
    yield put({
      type: ADMIN_CREATE_INSURANCE_FAILURE,
      error: true,
      payload: e,
    });

    action.payload.onSaveError && action.payload.onSaveError();
  }
}

function* updateInsurance(action: any): any {
  try {
    const updateInsurance = yield call(ApiService.partialUpdateAdminInsurance, {
      id: action.payload.insurance.id,
      requestBody: action.payload.insurance,
    });

    yield put({
      type: ADMIN_UPDATE_INSURANCE_SUCCESS,
      payload: {
        case_id: action.payload.caseId,
        patient_id: updateInsurance.patient_id,
        insurance: updateInsurance,
      },
    });

    action.payload.onClose && action.payload.onClose(null);
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_INSURANCE_FAILURE,
      error: true,
      payload: e,
    });

    action.payload.onSaveError && action.payload.onSaveError();
  }
}

function* updateLocation(action: any): any {
  try {
    const location = yield call(ApiService.partialUpdateLocation, {
      id: action.payload.location.id,
      requestBody: action.payload.location,
    });

    yield put({
      type: ADMIN_UPDATE_PATIENT_LOCATION_SUCCESS,
      payload: location,
    });

    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_PATIENT_LOCATION_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* createPatientGuarantor(action: any): any {
  try {
    const guarantor = yield call(ApiService.createPatientGuarantor, {
      requestBody: action.payload,
    });

    yield put({
      type: ADMIN_CREATE_PATIENT_GUARANTOR_SUCCESS,
      payload: guarantor,
    });

    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_CREATE_PATIENT_GUARANTOR_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* updatePatientGuarantor(action: any): any {
  try {
    const guarantor = yield call(ApiService.partialUpdatePatientGuarantor, {
      id: action.payload.id,
      requestBody: action.payload,
    });

    yield put({
      type: ADMIN_UPDATE_PATIENT_GUARANTOR_SUCCESS,
      payload: guarantor,
    });

    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_UPDATE_PATIENT_GUARANTOR_FAILURE,
      error: true,
      payload: e,
    });
  }
}

function* deleteInsurance(action: any): any {
  try {
    yield call(ApiService.destroyAdminInsurance, { id: action.payload.id });
    yield put({
      type: ADMIN_DELETE_INSURANCE_SUCCESS,
      payload: {
        id: action.payload.id,
      },
    });

    action.payload.onClose && action.payload.onClose();
  } catch (e) {
    yield put({
      type: ADMIN_DELETE_INSURANCE_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* adminPatientSaga() {
  yield takeLatest(ADMIN_UPDATE_PATIENT_REQUEST, savePatient);
  yield takeLatest(ADMIN_CREATE_INSURANCE_REQUEST, createInsurance);
  yield takeLatest(ADMIN_UPDATE_INSURANCE_REQUEST, updateInsurance);
  yield takeLatest(ADMIN_UPDATE_PATIENT_LOCATION_REQUEST, updateLocation);
  yield takeLatest(ADMIN_DELETE_INSURANCE_REQUEST, deleteInsurance);
  yield takeLatest(
    ADMIN_CREATE_PATIENT_GUARANTOR_REQUEST,
    createPatientGuarantor
  );
  yield takeLatest(
    ADMIN_UPDATE_PATIENT_GUARANTOR_REQUEST,
    updatePatientGuarantor
  );
}
